import Blacklight from '../blacklight'
import $ from 'jquery'
import * as Leaflet from 'leaflet/dist/leaflet-src.esm'
import 'leaflet/dist/leaflet.css'

const iconRetinaUrl = new URL('leaflet/dist/images/marker-icon-2x.png', import.meta.url).href;
const iconUrl = new URL('leaflet/dist/images/marker-icon.png', import.meta.url).href;
const shadowUrl = new URL('leaflet/dist/images/marker-shadow.png', import.meta.url).href;

function initialize(){
    $('[data-coordinates]:not(.leaflet-container)').each((i, el) => {
        const coordinates = $(el).data('coordinates').split(/, */).map(parseFloat);
        const instName = $(el).data('inst-name');
        const googleLink = $(el).data('google-link');
        const tileUrl = $(el).data('tile-url');
        const linkElem =  $('<a>',{
            text: instName,
            href: googleLink
        });
        const map = Leaflet.map(el, {
            scrollWheelZoom: false,
            center: coordinates,
            zoom: 11
        });
        Leaflet.tileLayer(
            tileUrl,
            {
                id: 'osm.default',
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>'
            }
        ).addTo(map);
        delete Leaflet.Icon.Default.prototype._getIconUrl;
        Leaflet.Icon.Default.mergeOptions({
            iconRetinaUrl,
            iconUrl,
            shadowUrl,
        });
        Leaflet.marker(coordinates)
            .addTo(map)
            .bindPopup(linkElem.prop('outerHTML'))
            .openPopup();
    });
}

Blacklight.onLoad(initialize);
initialize();
